<template>
  <div class="ma3 ma4-l flex flex-column mw7">
    <div>
      <h1 class="ma0 pa0 f4 b">Сервис работает в демонстрационном режиме!</h1>
      <p class="lh-copy">
        <ul class="ma0 ml3 pa0">
          <li>Используются вымышленные данные</li>
          <li>Разделы  сайта работают с ограничениями</li>
        </ul>
      </p>
    </div>
    <div class="mt4">
      <h1 class="ma0 pa0 f4 b">Ограничения</h1>
    </div>
    <div class="mt4">
      <h1 class="ma0 pa0 f5 b">Дашборд</h1>
      <p class="lh-copy">Графики дашборда строятся на фиксированном наборе вымышленных данных. <span class="i">Выбор интервала и деление его по дням игнорируется и не влияет на их построение.</span></p>
    </div>
    <div class="mt4">
      <h1 class="ma0 pa0 f5 b">Отчеты</h1>
      <p class="lh-copy">Отчеты формируются на основе вымышленных данных. <span class="i">Параметры указанные при формировании отчетов - игнорируются.</span></p>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isDemo () {
      return this.$store.getters['user/user'].demo
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
